/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  REGIME_PLACEHOLDER,
  REGISTER_PLACEHOLDER,
} from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AssetGroupBaseDto } from '../models/asset-group-base.dto';
import { AssetGroupGLAccountDto } from '../models/asset-group-glaccount.dto';
import { BulkUpdateAssetGroupDepreciationCommand } from '../models/asset-groups/bulk-update-asset-group-depreciation.command';
import { BulkUpsertGlAccountsCommand } from '../models/asset-groups/bulk-upsert-gl-accounts.command';
import { ListAssetGroupsSimpleQuery } from '../models/asset-groups/list-asset-groups-simple.query';
import { ListAssetGroupsWithGlAccountsQuery } from '../models/asset-groups/list-asset-groups-with-gl-accounts.query';
import { ListParentAssetGroupsResponse } from '../models/asset-groups/list-parent-asset-groups.response';
import { SaveClassificationGlAccountsCommand } from '../models/classifications/save-classification-gl-accounts.command';
import { ListClassificationGlAccountsQuery } from '../models/fields/list-classification-gl-accounts.query';
import { ListClassificationGlAccountsResponse } from '../models/fields/list-classification-gl-accounts.response';
import { OperationResponse } from '../models/generic/operation-response';
import { GetAssetCountResponse } from '../models/registers/get-asset-count.response';
import { GetAssetTotalsQuery } from '../models/registers/get-asset-totals.query';
import { GetAssetTotalsResponse } from '../models/registers/get-asset-totals.response';
import { GetDepreciationClassificationsQuery } from '../models/registers/get-depreciation-classifications.query';
import { GetDepreciationClassificationsResponse } from '../models/registers/get-depreciation-classifications.response';
import { GetGroupTotalsQuery } from '../models/registers/get-group-totals.query';
import { GetGroupTotalsResponse } from '../models/registers/get-group-totals.response';
import { GetPoolAssetTotalsQuery } from '../models/registers/get-pool-asset-totals.query';
import { SearchAssetsExportQuery } from '../models/registers/search-assets-export.query';
import { SearchAssetsV2Query } from '../models/registers/search-assets-v2.query';
import { SearchAssetsV2Response } from '../models/registers/search-assets-v2.response';
import { UsageWarningQuery } from '../models/registers/usage-warning.query';
import { UsageWarningDto } from '../models/usage-warning.dto';

@Injectable({
  providedIn: 'root',
})
export class RegisterV3Api {
  constructor(private http: HttpClient) {}

  bulkUpdateAssetGroupDepreciation(
    command: BulkUpdateAssetGroupDepreciationCommand,
  ): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/assetgroup-depreciation`,
      command,
    );
  }

  bulkUpsertGlAccounts(command: BulkUpsertGlAccountsCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/glAccounts`,
      command,
    );
  }

  checkUsage(command: UsageWarningQuery): Observable<UsageWarningDto[]> {
    return this.http.post<UsageWarningDto[]>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/check-usage`,
      command,
    );
  }

  getAssetCount(registerId?: number | null): Observable<GetAssetCountResponse> {
    return this.http.get<GetAssetCountResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${registerId ?? REGISTER_PLACEHOLDER}/asset-count`,
    );
  }

  getAssetTotals(command: GetAssetTotalsQuery): Observable<GetAssetTotalsResponse> {
    return this.http.get<GetAssetTotalsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/groups/${command.assetGroupId}/totals`,
      { params: { ...(command.top ? { top: command.top } : {}) } },
    );
  }

  getDepreciationClassifications(
    command: GetDepreciationClassificationsQuery = {},
  ): Observable<GetDepreciationClassificationsResponse> {
    return this.http.get<GetDepreciationClassificationsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/depreciation-classifications`,
    );
  }

  getGroupTotals(command: GetGroupTotalsQuery = {}): Observable<GetGroupTotalsResponse> {
    return this.http.get<GetGroupTotalsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/totals`,
    );
  }

  getPoolAssetTotals(command: GetPoolAssetTotalsQuery): Observable<GetAssetTotalsResponse> {
    return this.http.get<GetAssetTotalsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/groups/pools/${command.poolCode}/totals`,
      { params: { ...(command.top ? { top: command.top } : {}) } },
    );
  }

  listAssetGroupsSimple(
    query: ListAssetGroupsSimpleQuery = {},
  ): Observable<OperationResponse<AssetGroupBaseDto[]>> {
    return this.http.get<OperationResponse<AssetGroupBaseDto[]>>(
      `${environment.servicesApiUrl}/api/v3/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/asset-groups-simple`,
      { params: { ...(query.includeInactive ? { includeInactive: query.includeInactive } : {}) } },
    );
  }

  listAssetGroupsWithGlAccounts(
    query: ListAssetGroupsWithGlAccountsQuery = {},
  ): Observable<OperationResponse<AssetGroupGLAccountDto[]>> {
    return this.http.get<OperationResponse<AssetGroupGLAccountDto[]>>(
      `${environment.servicesApiUrl}/api/v3/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/asset-groups-gl-accounts`,
      { params: { ...(query.includeInactive ? { includeInactive: query.includeInactive } : {}) } },
    );
  }

  listClassificationGlAccounts(
    command: ListClassificationGlAccountsQuery,
  ): Observable<ListClassificationGlAccountsResponse> {
    return this.http.get<ListClassificationGlAccountsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/classifications/${command.classificationId}/glAccounts`,
    );
  }

  listParentAssetGroups(registerId?: number | null): Observable<ListParentAssetGroupsResponse> {
    return this.http.get<ListParentAssetGroupsResponse>(
      `${environment.servicesApiUrl}/api/v3/registers/${registerId ?? REGISTER_PLACEHOLDER}/parentAssetGroups`,
    );
  }

  saveClassificationGlAccounts(command: SaveClassificationGlAccountsCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/classifications/${command.classificationId}/glAccounts`,
      command,
    );
  }

  searchAssetsExport(query: SearchAssetsExportQuery = {}): Observable<Blob> {
    return this.http.get(
      `${environment.servicesApiUrl}/api/v3/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/regimes/${query.regimeId ?? REGIME_PLACEHOLDER}/search-export`,
      {
        params: {
          ...(query.columns ? { columns: query.columns } : {}),
          ...(query.bulkAction ? { bulkAction: query.bulkAction } : {}),
          ...(query.simpleSearch ? { simpleSearch: query.simpleSearch } : {}),
          ...(query.includeInactive ? { includeInactive: query.includeInactive } : {}),
          ...(query.assetGroupId ? { assetGroupId: query.assetGroupId } : {}),
          ...(query.assetType ? { assetType: query.assetType } : {}),
          ...(query.fields ? { fields: query.fields } : {}),
          ...(query.unassignedClassifications
            ? { unassignedClassifications: query.unassignedClassifications }
            : {}),
          ...(query.events ? { events: query.events } : {}),
          ...(query.depreciationMethodId
            ? { depreciationMethodId: query.depreciationMethodId }
            : {}),
          ...(query.poolCode ? { poolCode: query.poolCode } : {}),
        },
        responseType: 'blob',
      },
    );
  }

  searchAssetsV2(command: SearchAssetsV2Query = {}): Observable<SearchAssetsV2Response> {
    return this.http.get<SearchAssetsV2Response>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/search`,
      {
        params: {
          ...(command.top ? { top: command.top } : {}),
          ...(command.pageSize ? { pageSize: command.pageSize } : {}),
          ...(command.columns ? { columns: command.columns } : {}),
          ...(command.simpleSearch ? { simpleSearch: command.simpleSearch } : {}),
          ...(command.includeInactive ? { includeInactive: command.includeInactive } : {}),
          ...(command.assetGroupId ? { assetGroupId: command.assetGroupId } : {}),
          ...(command.assetType ? { assetType: command.assetType } : {}),
          ...(command.fields ? { fields: command.fields } : {}),
          ...(command.unassignedClassifications
            ? { unassignedClassifications: command.unassignedClassifications }
            : {}),
          ...(command.events ? { events: command.events } : {}),
          ...(command.depreciationMethodId
            ? { depreciationMethodId: command.depreciationMethodId }
            : {}),
          ...(command.poolCode ? { poolCode: command.poolCode } : {}),
        },
      },
    );
  }
}
